export default __webpack_public_path__ + "static/media/ad-big-2.0c058b69.jpeg";